import { Card, CardBody, Col, Label, Table } from "reactstrap";
import { SellingProductHeader } from "./SellingProductHeader";
import { SellingProductTabbleBody } from "./SellingProductTabbleBody";
import { SellingProductTableHead } from "./SellingProductTableHead";

const SellingProduct = () => {
  return (
    <Col xs="12">
      <Card>
        <SellingProductHeader />
        <CardBody className="pt-0 sellingproduct">
          <div className="table-responsive theme-scrollbar">
            <div id="selling-product_wrapper" className="dataTables_wrapper no-footer">
              <div id="selling-product_filter" className="dataTables_filter">
                <Label>Search:<input type="search"/></Label>
              </div>
              <Table className="display dataTable" id="selling-product">
                <SellingProductTableHead />
                <SellingProductTabbleBody />
              </Table>
            </div>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default SellingProduct;
